import { MemberGroups } from "shared-types";
import { getUserGroup } from "../services/authorization";

export default function checkIsPerformer() {
  return [
    MemberGroups.performer,
    MemberGroups.yPerformer,
    MemberGroups.graduatePerformer,
  ].includes(getUserGroup() as MemberGroups);
}
